export enum leaveReasonApartmentEnum {
	family = 1,
	professional = 2,
	otherType = 4,
	neighbour = 7,
	acquisition = 8,
	budget = 10,
	residence = 12,
	apartment = 13,
	other = 17
}

export enum leaveReasonCampusEnum {
	changeSchool = 18,
	changeStatus = 19,
	intership = 20,
	otherType = 4,
	unsatisfied = 12,
	foundCheaper = 21,
	surrounding = 22,
	other = 17
}

export enum leaveReasonParkingEnum {
	vehicle = 3,
	otherType = 6,
	acquisition = 8,
	principalChanged = 9,
	professional = 11,
	parking = 14,
	residence = 12,
	other = 17
}

export enum leaveReasonBothEnum {
	family = 1,
	professional = 2,
	otherType = 5,
	neighbour = 7,
	acquisition = 8,
	budget = 10,
	residence = 15,
	apartment = 16,
	other = 17
}
